<template>
  <div class="login-container">
    <h5>欢迎登录58option期权查询系统</h5>
    <form @submit.prevent="handleLogin" class="login-form">
      <div class="form-group">
        <label for="username">用户名/手机号</label>
        <input type="text" id="username" placeholder="请输入用户名/手机号" v-model="credentials.username" required />
      </div>
      <div class="form-group">
        <label for="password">密码</label>
        <input type="password" id="password" placeholder="请输入密码" v-model="credentials.password" required />
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" v-model="rememberMe" /> 记住用户名和密码
        </label>
      </div>
      <button type="submit">登录</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      rememberMe: false
    };
  },
  methods: {
    async handleLogin() {
      try {
        await this.$store.dispatch('login', this.credentials);
        if (this.rememberMe) {
          // 将用户名和密码保存到本地存储
          localStorage.setItem('username', this.credentials.username);
          localStorage.setItem('password', this.credentials.password);
        } else {
          // 清除本地存储中的用户名和密码
          localStorage.removeItem('username');
          localStorage.removeItem('password');
        }
        this.$router.push('/stock-search-form'); // 登录成功后跳转到主页或其他页面
      } catch (error) {
         console.error('登录失败:', error);
         const errorMessage = error.response?.data?.detail || '登录失败，请重试';
         alert(errorMessage); // 使用 alert 弹出错误信息
      }
    }
  },
  mounted() {
    // 页面加载时检查本地存储中是否有保存的用户名和密码
    const savedUsername = localStorage.getItem('username');
    const savedPassword = localStorage.getItem('password');
    if (savedUsername && savedPassword) {
      this.credentials.username = savedUsername;
      this.credentials.password = savedPassword;
      this.rememberMe = true;
    }
  }
};
</script>

<style scoped>
.login-container {
  padding: 20px; /* 减少内边距 */
  max-width: 90%; /* 使用百分比宽度 */
  margin: 20px auto;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: 'Roboto', sans-serif;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f7f7ff, #e9e9f8);
  z-index: -1;
}

h5 {
  font-size: 18px; /* 减少标题字体大小 */
  margin-bottom: 20px;
  color: #333;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-group {
  margin-bottom: 15px; /* 减少表单项之间的间距 */
  width: 100%;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-size: 14px; /* 减少标签字体大小 */
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px; /* 减少输入框内边距 */
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 14px; /* 减少输入框字体大小 */
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="text"]:focus,
input[type="password"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.25);
  outline: none;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px; /* 减少按钮内边距 */
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px; /* 减少按钮字体大小 */
  transition: background-color 0.3s, transform 0.3s, box-shadow 0.3s;
}

button:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media (max-width: 576px) {
  .login-container {
    padding: 15px; /* 进一步减少内边距 */
    margin: 15px auto;
  }

  h5 {
    font-size: 16px; /* 进一步减少标题字体大小 */
    margin-bottom: 15px;
  }

  input[type="text"],
  input[type="password"] {
    font-size: 12px; /* 进一步减少输入框字体大小 */
  }

  button {
    font-size: 12px; /* 进一步减少按钮字体大小 */
  }
}
</style>
